import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { UiIcon } from "../Icon";
import classes from "./hello-bar.scss";

// Switched off for now; set to true to show the bar again
export const HELLO_BAR_ON = false;

// Kept for 30 days once closed (or once someone follows the link); the server reads it,
// so a closed bar never flashes in on the next visit
export const HELLO_BAR_COOKIE = "kirki_bar_dismissed";
const DAYS = 30;

// What the bar says depends on what you're doing here. Claims come from Kirki's
// WordPress.org listing
const MESSAGES = [
  {
    match: (path) => path === "/studio",
    campaign: "studio",
    text: "Designing icons for a WordPress site? Build the pages around them with Kirki, the freeform visual builder.",
    short: "Build WordPress pages freely",
  },
  {
    match: (path) => path === "/composer",
    campaign: "composer",
    text: "Shipping a WordPress theme? Kirki is a freeform visual builder and an advanced theme customizer in one.",
    short: "Builder + theme customizer",
  },
  {
    match: () => true,
    campaign: "site",
    text: "Building with WordPress? Design pages freely with Kirki, the visual builder on 500,000+ sites.",
    short: "Freeform WordPress builder",
  },
];

const remember = () => {
  document.cookie = `${HELLO_BAR_COOKIE}=1; max-age=${DAYS * 24 * 60 * 60}; path=/; samesite=lax`;
};

export const HelloBar = ({ pathname, onDismiss }) => {
  const message = MESSAGES.find((item) => item.match(pathname));
  const href = `https://kirki.com/?utm_source=icofont&utm_medium=hellobar&utm_campaign=${message.campaign}`;
  const dismiss = () => {
    remember();
    onDismiss();
  };

  return (
    <div className={classes.bar} role="region" aria-label="Sponsored">
      <div className={classes.inner}>
        <span className={classes.tag}>Ad</span>
        <p className={classes.text}>
          <span className={classes.long}>{message.text}</span>
          <span className={classes.short}>{message.short}</span>
        </p>
        <a
          className={classes.cta}
          href={href}
          target="_blank"
          rel="sponsored noopener"
          // Someone who went to look doesn't need asking again
          onClick={remember}
        >
          <span className={classes.long}>Try Kirki free</span>
          <span className={classes.short}>Try Kirki</span>
          <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M5 3h8v8M13 3 3 13" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
        <button type="button" className={classes.close} onClick={dismiss} aria-label="Hide this for 30 days" title="Hide for 30 days">
          <UiIcon name="close-line" />
        </button>
      </div>
    </div>
  );
};

HelloBar.propTypes = {
  pathname: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default connect(null, (dispatch) => ({
  onDismiss: () => dispatch({ type: "SET_BANNER_DISMISSED", dismissed: true }),
}))(HelloBar);
